import { useEffect, useState } from "react";

export function useResizeObserver<T extends HTMLElement>(
  ref: React.RefObject<T>,
) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries)) return;
      const entry = entries[0];
      if (entry) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });

    resizeObserver.observe(element);

    // Set size initially in case ResizeObserver delays
    setSize({
      width: element.offsetWidth,
      height: element.offsetHeight,
    });

    return () => resizeObserver.disconnect();
  }, [ref.current]); // react to element mounting

  return size;
}
